import api from '../../api';
import { Metadata, Product } from '@deliveries-app/models';
import {
  GetAllProductFilters,
  ProductPayload,
} from '../models/product-request.interface';
import { processFilterParams } from '../utils/filterParams';
import {
  DetailProductResponse,
  ProductResponse,
} from '../models/product-response.interface';

export async function getProducts(): Promise<Product[]> {
  try {
    const res = await api.get<{ data: Product[] }>('/api/v1/products');

    return res.data.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

/**
 * Get all products by branch id
 *
 * @param {number} branch_id
 *
 * @returns {Promise<Product[]>}
 */
export async function getAllProducts(
  branch_id: string | number,
  filters?: GetAllProductFilters
): Promise<{
  data: Product[];
  _metadata: Metadata;
}> {
  try {
    const params = processFilterParams({ filters: filters ?? {} });

    const response = await api.get<ProductResponse>(
      `/api/v1/branches/${branch_id}/product`,
      {
        params,
      }
    );

    return response.data;
  } catch (error: any) {
    console.error('getAllProduct failed', error);
    throw error.message;
  }
}

export async function createProduct(
  branch_id: string | number,
  payload_create: ProductPayload
): Promise<Product> {
  try {
    const responseCreate = await api.post<DetailProductResponse>(
      `/api/v1/branches/${branch_id}/product/create`,
      payload_create
    );

    return responseCreate.data.data;
  } catch (error: any) {
    console.error('failed create product!', error);

    throw error;
  }
}

export async function updateProduct(
  branch_id: string | number,
  payload_update: ProductPayload,
  id: string | number
): Promise<Product> {
  try {
    const responseUpdate = await api.patch<DetailProductResponse>(
      `/api/v1/branches/${branch_id}/product/${id}`,
      payload_update
    );

    return responseUpdate.data.data;
  } catch (error: any) {
    console.error('failed update product!', error);

    throw error;
  }
}

export async function deleteProduct(
  branch_id: string | number,
  id: number
): Promise<string> {
  try {
    const response = await api.delete(
      `/api/v1/branches/${branch_id}/product/${id}`
    );

    return response.data.message;
  } catch (error) {
    console.error('failed to delete product!', error);
    throw error;
  }
}

export const productService = {
  getProducts,
  getAllProducts,
  createProduct,
  updateProduct,
  deleteProduct,
};
